<template>
    <asli-quote-declined :title="pageTitle">
        <p class="text-center" v-html="errorMessage"></p>
    </asli-quote-declined>
    <div v-if="exceededMaxPaymentAttempts" class="text-center md:text-right">
        <asli-button :href="`tel:${BRAND_PHONE_NUMBER}`" color="primary">{{ BRAND_PHONE_NUMBER }}</asli-button>
    </div>
    <asli-divider class="my-[30px]" />
    <div v-if="!exceededMaxPaymentAttempts" class="text-center md:text-left mb-[30px]">
        <asli-button id="payment-failed-return-to-payment-page" color="primary" @click="goBack"> Retry </asli-button>
    </div>
</template>

<script lang="ts" setup>
import { AsliDivider, AsliQuoteDeclined, AsliButton, AsliLink, appendDecimal } from "@mbs-npm/anpost-ui";
import { ROUTE_NAMES } from "@/router/types";
import { useProposalStore } from "@/stores/risk/risk";
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { BRAND_PHONE_NUMBER } from "@/static/constants";
import { useMainStore } from "@/stores/main";

const router = useRouter();
const mainStore = useMainStore();
const proposalStore = useProposalStore();
const proposal = computed(() => proposalStore.proposal);
const quoteReference = computed(() => proposal.value.quote.reference);

const exceededMaxPaymentAttempts = computed(() => proposal.value.payment_attempts_exceeded);
const paymentAttemptsRemaining = computed(() => proposal.value.payment_attempts_remaining);
const pageTitle = exceededMaxPaymentAttempts.value
    ? `We're sorry ${proposal.value.risk.proposer.personal_details.first_name}!`
    : "Payment Attempt Failed";
const payment = computed(() =>
    proposal.value.is_pay_monthly ? proposal.value.quote.monthly_deposit : proposal.value.quote.premium
);

const errorMessage = computed(() => {
    return exceededMaxPaymentAttempts.value
        ? `
            We've not been able to process your payment of €${appendDecimal(
                payment.value?.toString(),
                true
            )} online. You have exceeded your maximum number of attempts.
            <br />
            Don't worry though, you can call us on the number below and we will help you in processing the payment.
            <br />
            Please use the following quote reference when calling: ${quoteReference.value}
        `
        : `Unfortunately there was a problem with your payment, please try again or contact us on ${BRAND_PHONE_NUMBER}.
            You have ${paymentAttemptsRemaining.value ?? ""}
            ${paymentAttemptsRemaining.value && paymentAttemptsRemaining.value === 1 ? "attempt" : "attempts"} remaining
        `;
});

onMounted(() => {
    mainStore.setFromPaymentFailed(true);
});

function goBack() {
    const routeName = proposal.value.is_pay_monthly ? ROUTE_NAMES.DirectDebit : ROUTE_NAMES.Payment;
    router.push({
        name: routeName,
        query: {
            uuid: proposalStore.proposal.uuid
        }
    });
}
</script>
